import { CorpType } from '@financial/asset-constants';
import { BiDefaultSb, BiDefaultCapital, BiDefaultIs, BiDefaultIv } from '../../../assets/defaults/index.mjs';
import { DEFAULT_SIZE } from '../constants/index.mjs';
import { jsx } from 'react/jsx-runtime';

const DefaultImageMap = {
  [CorpType.BANK]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultSb, {
      height: height,
      width: width
    });
  },
  [CorpType.CAPITAL]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultCapital, {
      height: height,
      width: width
    });
  },
  [CorpType.CARD]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultSb, {
      height: height,
      width: width
    });
  },
  [CorpType.INSURANCE]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultIs, {
      height: height,
      width: width
    });
  },
  [CorpType.INVEST]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultIv, {
      height: height,
      width: width
    });
  },
  [CorpType.POINT]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultSb, {
      height: height,
      width: width
    });
  },
  [CorpType.SAVING_BANK]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultSb, {
      height: height,
      width: width
    });
  },
  [CorpType.TELECOM]: function () {
    let height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SIZE;
    let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
    return /*#__PURE__*/jsx(BiDefaultSb, {
      height: height,
      width: width
    });
  }
};
var DefaultImageMap$1 = DefaultImageMap;

export { DefaultImageMap$1 as default };
